<div class="empty-state">
  <div class="empty-state--icons">
    @for (icon of icons(); track icon) {
      <service-icon [type]="icon.toLowerCase()" [active]="false" />
    }
  </div>
  <div>
    <h3>{{ title() }}</h3>
    <span [innerHtml]="'ServiceElement.EmptyState.Description' | translate | safe: 'html'"></span>
  </div>
</div>
